import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'space-invaders-banner',
    templateUrl: './space-invaders.component.html',
    styleUrls: ['./space-invaders.component.css'],
    standalone: false
})
export class SpaceInvadersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
